import React from 'react';
import './index.styl';
import Board from './Board/index';
import {DIRECTION} from 'common/js/params';
// import classnames from 'classnames';

const clzpre = 'env-chart-property';

class ChartProperty extends React.Component{
    render() {
        const {data} = this.props;
        const {children} = data;
        return (
            <section className={clzpre}>
                <div className={'chartWrapper'}>
                    {children.map((c) => {
                        if(['wind_direction'].indexOf(c.key) < 0) {
                            return (
                                <div
                                    key={c.key}
                                >
                                    <Board
                                        mainInfo={data}
                                        data={c}
                                    />
                                </div>
                            );
                        } else {
                            return (
                                <div
                                    key={c.key}
                                >{DIRECTION[c.value]}风</div>
                            );
                        }
                    })}
                </div>
                <footer>{data.name}</footer>
            </section>
        );
    }
}

export default ChartProperty;
